import React from "react";
import { Outlet } from "react-router-dom";
import { styled } from "styled-components";
import Footer from "./Footer";
import Header from "./Header";

const LayoutContainer = styled.div`
  padding-top: 100px;
  overflow-x: hidden;
  @media all and (max-width: 1024px) {
    padding-top: 80px;
  }
  @media all and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const Layout = () => (
  <LayoutContainer>
    <Header />
    <div>
      <Outlet />
    </div>
    <Footer />
  </LayoutContainer>
);

export default Layout;
